import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const ShiftListContext = createContext()

export const ShiftListProvider = ({ children }) => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const data = await RequestService.getShiftList()
      setRows(data?.data || [])
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])


  return (
    <ShiftListContext.Provider
      value={{
        rows,
        loading,
      }}
    >
      {children}
    </ShiftListContext.Provider>
  )
}

export const useShiftList = () => {
  return useContext(ShiftListContext)
}
